import React from 'react';

import {
	ADMIN_JIRA_MACRO_REPAIR_ANALYTICS_SOURCE,
	LazyJiraMacroRepairPage,
} from '@confluence/site-settings';
import { ADMIN_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs';

export const AdminJiraMacroRepairRoute = () => <LazyJiraMacroRepairPage />;

AdminJiraMacroRepairRoute.NAVIGATION_PARAMS = () => ({
	Screen: {
		screenEvent: { name: ADMIN_JIRA_MACRO_REPAIR_ANALYTICS_SOURCE },
	},
	MainLayout: {
		navView: ADMIN_HOME_ID,
	},
});
